import type { PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

interface FilterOptionValueProps {
  value: string;
  numberOfArticles: number;
  isChecked: boolean;
}

interface NumberOfArticlesProps extends PropsWithChildren {
  isChecked: boolean;
}

const NumberOfArticles = styled.span<NumberOfArticlesProps>`
  color: ${({ isChecked }) =>
    isChecked
      ? themeGet('colors.sys.primary.background.default')
      : themeGet('colors.sys.neutral.border.default')};
`;

const FilterOptionValue = ({ value, numberOfArticles, isChecked }: FilterOptionValueProps) => {
  return (
    <>
      {value} <NumberOfArticles isChecked={isChecked}>({numberOfArticles})</NumberOfArticles>
    </>
  );
};

export default FilterOptionValue;
